import each from 'lodash-es/each';
import debounce from 'lodash-es/debounce';
import Flickity from 'flickity';

const carousels = [];

const init = () => {
  each(carousels, (carousel) => {
    try {
      carousel.destroy();
    } catch (error) {
      console.log('err:', error);
    }
  });

  carousels.length = 0;

  const config =
    window.innerWidth > 767
      ? {
          imagesLoaded: true,
          cellAlign: 'left',
          contain: false,
          groupCells: false,
          draggable: true,
          dragThreshold: 10,
          wrapAround: true,
        }
      : {
          imagesLoaded: true,
          cellAlign: 'center',
          contain: false,
          groupCells: false,
          draggable: true,
          dragThreshold: 10,
          wrapAround: true,
        };

  document.querySelectorAll('[data-carousel-lookbook]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    } else {
      el.setAttribute('initialized', 'true');
    }

    const carousel = new Flickity(el, config);

    carousels.push(carousel);
  });
};

let prevWidth = window.innerWidth;

const handleResize = debounce(() => {
  const newWidth = window.innerWidth;
  const deltaWidth = newWidth - prevWidth;

  if (deltaWidth === 0) {
    return;
  }

  prevWidth = newWidth;

  init();
}, 500);

export default function () {
  if (document.querySelectorAll('[data-carousel-lookbook]').length === 0) {
    return;
  }

  console.log('!!! Init Carousel Lookbook');

  init();

  window.addEventListener('resize', handleResize);
}
